import { render, staticRenderFns } from "./SiteIcon.vue?vue&type=template&id=b4872eea"
import script from "./SiteIcon.vue?vue&type=script&lang=js"
export * from "./SiteIcon.vue?vue&type=script&lang=js"
import style0 from "./SiteIcon.vue?vue&type=style&index=0&id=b4872eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports